import {
  Tooltip,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./anomalieStyle";
import { selectKenngroesseWertTemp } from "../../../features/filter/kenngroesseSlice";
import { selectMessstelleWertTemp } from "../../../features/filter/messstellenFilterSlice";
import {
  selectStartDatumTemp,
  selectEndeDatum,
} from "../../../features/filter/zeitSlice";
import { anomalieGeneralObject } from "./anomalieTypes";
import {
  selectKenngroesseListe,
  selectVertikalSumListe,
  selectHorizentalSumListe,
  selectSumAll,
  selectAnomalieListe,
} from "./anomalieGeneralGridSlice";
import { getAnomalieDetail, selectAnomalieDetailedList } from "./anomalieDetailedGridSlice";
import {
  selectAnomalietypTemp,
  selectSignifikanzTemp,
} from "./anomalieFilterSlice";
import { setSelectedTab } from "./anomalieSlice";
import { openSnackbar } from "../../../features/snackbar/globalSnackbarSlice";

export default function AnomalieGeneralGrid(): ReactElement {
  const dispatch = useAppDispatch();
  const classes = {
    ...globalStyles(),
    ...useStyles(),
  };


  const kenngroesseFilterWert = useAppSelector(selectKenngroesseWertTemp);
  const messstelleFilterWert = useAppSelector(selectMessstelleWertTemp);
  const liste_header = useAppSelector(selectKenngroesseListe);
  const liste_horizontal = useAppSelector(selectHorizentalSumListe);
  const liste_vertikal = useAppSelector(selectVertikalSumListe);
  const sum_all = useAppSelector(selectSumAll);
  const anomalieListe = useAppSelector(selectAnomalieListe);

  const startDatum = useAppSelector(selectStartDatumTemp);
  const endeDatum = useAppSelector(selectEndeDatum);
  const anomalientypen = useAppSelector(selectAnomalietypTemp);
  const signifikanz = useAppSelector(selectSignifikanzTemp);

  const tabList = useAppSelector(selectAnomalieDetailedList);

  const [selectedHeader, setSelectedHeader] = React.useState({
    horizontal: "",
    vertikal: "",
  });


  function detailedAnomalieHandler(row: anomalieGeneralObject) {
    const tempTab: string = row.col + row.row;
    dispatch(setSelectedTab(tempTab));
    dispatch(
      getAnomalieDetail(
        messstelleFilterWert,
        kenngroesseFilterWert,
        startDatum,
        endeDatum,
        anomalientypen,
        signifikanz,
        row.row,
        row.col
      )
    );
  }

  function tooManyTabs() {
    dispatch(openSnackbar({
      message: "Es können maximal 5 Detailtabs geöffnet werden",
      severity: "info",
      duration: 6000,
    }))
  }

  function createTableCell(elem: string, rows: anomalieGeneralObject[]) {
    const rowsMaxIndex = rows.length;
    let rowsIndex = 0;
    while (rowsMaxIndex > rowsIndex) {
      // eslint-disable-next-line security/detect-object-injection
      if (elem == rows[rowsIndex].col) {
        // eslint-disable-next-line security/detect-object-injection
        return (
          <TableCell
            className={classes.tableCellClickable}
            style={{ cursor: "pointer" }}
            // eslint-disable-next-line security/detect-object-injection
            onClick={() => { tabList.length > 4 ? tooManyTabs() : detailedAnomalieHandler(rows[rowsIndex]) }}
            onMouseEnter={() => {
              setSelectedHeader({
                // eslint-disable-next-line security/detect-object-injection
                horizontal: rows[rowsIndex].col,
                // eslint-disable-next-line security/detect-object-injection
                vertikal: rows[rowsIndex].row,
              });
            }}
          >
            {
              // eslint-disable-next-line security/detect-object-injection
              rows[rowsIndex].value
            }
          </TableCell>
        );
      }
      rowsIndex += 1;
    }
    return (
      <Tooltip title="Keine Daten">
        <TableCell className={classes.tableCellKursivStyle}></TableCell>
      </Tooltip>
    );
  }
  return (
    <React.Fragment>
      <Grid item md={12} style={{ textAlign: "left", marginRight: "20px" }}>
        <div>
          <TableContainer component={Paper} style={{ height: "80vh" }}>
            <Table aria-label="simple table" className={classes.table}>
              <TableHead>
                <TableCell className={classes.tableHeaderHorizontalLeftmost}>
                  Messstelle / Kenngröße
                </TableCell>
                {liste_header.map((elem, index) => (
                  <TableCell
                    key={index}
                    className={
                      selectedHeader.horizontal == elem
                        ? `${classes.tableHeaderHorizontalFocused}`
                        : `${classes.tableHeaderHorizontal}`
                    }
                  >
                    {elem}
                  </TableCell>
                ))}
                <TableCell
                  className={classes.tableHeaderHorizontalBlank}
                  style={{ width: "20px" }}
                />
                <TableCell className={classes.tableHeaderHorizontal}>
                  Summe der Kenngrößen
                </TableCell>
              </TableHead>
              <TableBody>
                {anomalieListe.map((rows, index) => {

                  return (<TableRow key={rows[0].row}>
                    <TableCell
                      className={
                        // eslint-disable-next-line security/detect-object-injection
                        selectedHeader.vertikal == rows[index]?.row
                          ? `${classes.tableHeaderVerticalFocused}`
                          : `${classes.tableHeaderVertical}`
                      }
                      component="th"
                      scope="rows"
                    >
                      {rows[0].row}
                    </TableCell>
                    {liste_header.map((elem) => createTableCell(elem, rows))}
                    <TableCell
                      className={classes.tableCellBlank}
                      style={{ width: "20px" }}
                    />
                    {/* eslint-disable-next-line security/detect-object-injection */}
                    <TableCell className={classes.tableCellStyle}>
                      {
                        // eslint-disable-next-line security/detect-object-injection
                        liste_horizontal[index]
                      }
                    </TableCell>
                  </TableRow>)
                })}
                <TableRow>
                  <TableCell />
                </TableRow>
                <TableRow>
                  <TableCell
                    className={classes.tableHeaderVertical}
                    style={{ width: "295px" }}
                    component="th"
                    scope="rows"
                  >
                    Summe der Messstellen
                  </TableCell>
                  {liste_vertikal.map((elem, index) => (
                    <TableCell key={index} className={classes.tableCellStyle}>
                      {elem}
                    </TableCell>
                  ))}
                  <TableCell
                    className={classes.tableCellBlank}
                    style={{ width: "20px" }}
                  />
                  <TableCell className={classes.tableCellStyle}>
                    {sum_all}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Grid>
    </React.Fragment>
  );
}
